var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96875 5.68821C1.96875 3.91393 3.40709 2.47559 5.18137 2.47559H14.8192C16.5935 2.47559 18.0318 3.91393 18.0318 5.68821V17.6709C18.0318 18.3444 17.2528 18.7188 16.727 18.2981L14.8961 16.8334C14.3264 16.3776 13.6186 16.1294 12.8891 16.1294H5.18137C3.40709 16.1294 1.96875 14.691 1.96875 12.9167V5.68821Z",
    fill: "#B9D6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18066 10.9091C5.18066 10.2437 5.72004 9.70435 6.3854 9.70435H9.59802C10.2634 9.70435 10.8027 10.2437 10.8027 10.9091C10.8027 11.5744 10.2634 12.1138 9.59802 12.1138H6.3854C5.72004 12.1138 5.18066 11.5744 5.18066 10.9091Z",
    fill: "#8CBBC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18066 6.89345C5.18066 6.2281 5.72004 5.68872 6.3854 5.68872H13.6138C14.2791 5.68872 14.8185 6.2281 14.8185 6.89345C14.8185 7.55881 14.2791 8.09819 13.6138 8.09819H6.3854C5.72004 8.09819 5.18066 7.55881 5.18066 6.89345Z",
    fill: "#62A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool10);
export default __webpack_public_path__ + "static/media/tool_10.b406837a15f2ffc3e9ca31f10899c98c.svg";
export { ForwardRef as ReactComponent };